import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { emailRegEx, phoneRegEx } from '@shared/regexps';

import { fioSchema } from '../../../fio-fields';

export const registrationSchema = yup
  .object()
  .shape({
    birthDate: yup.string().required(i18n.t('COMMON:errors.required')),
    phone: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .matches(phoneRegEx, i18n.t('COMMON:errors.incorrectPhoneNumber')),
    email: yup
      .string()
      .required(i18n.t('COMMON:errors.required'))
      .matches(emailRegEx, i18n.t('COMMON:errors.incorrectEmail')),
  })
  .concat(fioSchema)
  .required();
